// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.radioButton__l55j0 {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.radioInput__Dlgyk {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  left: 0;
  top: 0;
  margin: unset;
}

.checkmark__E21GE {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 1px;
  left: 0;
  height: 13.5px;
  width: 13.5px;
  background-color: var(--inputs-filled-filled-surface);
  border: 1px solid var(--selection-controls-radio-surface-default);
  border-radius: 50%;
}

.radioLabel__zaR5h:hover input ~ .checkmark__E21GE {
  background-color: var(--inputs-filled-filled-surface);
}

.radioLabel__zaR5h input:checked ~ .checkmark__E21GE {
  background-color: var(--inputs-filled-filled-surface);
  border: 1px solid var(--selection-controls-radio-surface-default);
}

.radioLabel__zaR5h:has(input:checked) {
  font-weight: 700;
}

.checkmark__E21GE:after {
  content: "";
  position: absolute;
  display: none;
}

.radioLabel__zaR5h input:checked ~ .checkmark__E21GE:after {
  display: block;
}

.radioLabel__zaR5h .checkmark__E21GE:after {
  width: 7.5px;
  height: 7.5px;
  border-radius: 50%;
  background: var(--selection-controls-radio-surface-default);
}

.radioLabel__zaR5h {
  position: relative;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  text-transform: capitalize;
  padding-left: 24px;
  color: var(--selection-controls-toggle-text);
  cursor: pointer;
}

.radioLabelDisabled__Lmfi8 {
  color: var(--selection-controls-radio-text-disable);
  pointer-events: none;
}
.radioLabelDisabled__Lmfi8 .checkmark__E21GE {
  border: 1px solid var(--selection-controls-radio-surface-disable);
}

.radioLabelRtl__RUqKd {
  padding-right: 20px;
  padding-left: 0;
}

.checkmarkRtl__k8Jc3 {
  left: unset;
  right: 0;
}`, "",{"version":3,"sources":["webpack://./../src/components/uikit/RadioButton/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AAzEF;;AA4EA;EACE,kBAAA;EACA,UAAA;EACA,eAAA;EACA,OAAA;EACA,MAAA;EACA,aAAA;AAzEF;;AA4EA;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,OAAA;EACA,cAAA;EACA,aAAA;EACA,qDAAA;EACA,iEAAA;EACA,kBAAA;AAzEF;;AA4EA;EACE,qDAAA;AAzEF;;AA4EA;EACE,qDAAA;EACA,iEAAA;AAzEF;;AA4EA;EACE,gBAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,kBAAA;EACA,aAAA;AAzEF;;AA4EA;EACE,cAAA;AAzEF;;AA4EA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,2DAAA;AAzEF;;AA4EA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,0BAAA;EACA,kBAAA;EACA,4CAAA;EACA,eAAA;AAzEF;;AA4EA;EACE,mDAAA;EACA,oBAAA;AAzEF;AA2EE;EACE,iEAAA;AAzEJ;;AA6EA;EACE,mBAAA;EACA,eAAA;AA1EF;;AA6EA;EACE,WAAA;EACA,QAAA;AA1EF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.radioButton {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.radioInput {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  left: 0;\n  top: 0;\n  margin: unset;\n}\n\n.checkmark {\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  top: 1px;\n  left: 0;\n  height: 13.5px;\n  width: 13.5px;\n  background-color: var(--inputs-filled-filled-surface);\n  border: 1px solid var(--selection-controls-radio-surface-default);\n  border-radius: 50%;\n}\n\n.radioLabel:hover input ~ .checkmark {\n  background-color: var(--inputs-filled-filled-surface);\n}\n\n.radioLabel input:checked ~ .checkmark {\n  background-color: var(--inputs-filled-filled-surface);\n  border: 1px solid var(--selection-controls-radio-surface-default);\n}\n\n.radioLabel:has(input:checked) {\n  font-weight: 700;\n}\n\n.checkmark:after {\n  content: '';\n  position: absolute;\n  display: none;\n}\n\n.radioLabel input:checked ~ .checkmark:after {\n  display: block;\n}\n\n.radioLabel .checkmark:after {\n  width: 7.5px;\n  height: 7.5px;\n  border-radius: 50%;\n  background: var(--selection-controls-radio-surface-default);\n}\n\n.radioLabel {\n  position: relative;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 16px;\n  text-transform: capitalize;\n  padding-left: 24px;\n  color: var(--selection-controls-toggle-text);\n  cursor: pointer;\n}\n\n.radioLabelDisabled {\n  color: var(--selection-controls-radio-text-disable);\n  pointer-events: none;\n\n  .checkmark {\n    border: 1px solid var(--selection-controls-radio-surface-disable);\n  }\n}\n\n.radioLabelRtl {\n  padding-right: 20px;\n  padding-left: 0;\n}\n\n.checkmarkRtl {\n  left: unset;\n  right: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"radioButton": `radioButton__l55j0`,
	"radioInput": `radioInput__Dlgyk`,
	"checkmark": `checkmark__E21GE`,
	"radioLabel": `radioLabel__zaR5h`,
	"radioLabelDisabled": `radioLabelDisabled__Lmfi8`,
	"radioLabelRtl": `radioLabelRtl__RUqKd`,
	"checkmarkRtl": `checkmarkRtl__k8Jc3`
};
module.exports = ___CSS_LOADER_EXPORT___;
